import { Component, OnInit } from '@angular/core';
import { FlashController } from '../../flash-payment-core/services/flash-controller.service';

@Component({
  selector: 'app-payment-confirmation',
  templateUrl: './payment-confirmation.component.html',
  styleUrls: ['./payment-confirmation.component.sass']
})
export class PaymentConfirmationComponent implements OnInit {

  constructor(public flashPaymentService: FlashController) { }

  ngOnInit(): void {
  }

}
